module.exports = __webpack_public_path__ + "img/pause.77799b37.svg";